import { useState, useCallback } from 'react';

const useInquiry = () => {
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ 
    open: false, 
    message: '', 
    severity: 'success' 
  });

  const handleInquiryOpen = useCallback(() => {
    setInquiryOpen(true);
  }, []);

  const handleInquiryClose = useCallback(() => {
    setInquiryOpen(false);
  }, []);

  const handleInquirySubmit = useCallback((inquiryData) => {
    const emailSubject = `Product Inquiry - ${inquiryData.product}`;
    const emailBody = `
Customer Details:
- Name: ${inquiryData.name}
- Email: ${inquiryData.email}
- Phone: ${inquiryData.phone || 'Not provided'}

Product Details:
- Product: ${inquiryData.product}
- Brand: ${inquiryData.productBrand}
- Price: ${inquiryData.productPrice}

Message: ${inquiryData.message || 'Hi Team, I\'d like to inquire about this product. Please contact me with more details.'}
    `.trim();

    const mailtoLink = `mailto:info@skinnthrive.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
    
    window.location.href = mailtoLink;
    
    setSnackbar({
      open: true,
      message: 'Inquiry sent! Your email client should open shortly.',
      severity: 'success'
    });
  }, []);

  const handleSnackbarClose = useCallback(() => {
    setSnackbar(prev => ({ ...prev, open: false }));
  }, []);

  return {
    inquiryOpen,
    snackbar,
    handleInquiryOpen,
    handleInquiryClose,
    handleInquirySubmit,
    handleSnackbarClose
  };
};

export default useInquiry;